import { JSONSchemaType } from 'ajv'

export interface ITermFormData {
  acceptance: boolean
}

const TermSchema: JSONSchemaType<ITermFormData> = {
  type: 'object',
  properties: {
    acceptance: {
      type: 'boolean',
      errorMessage: 'Você deve aceitar os termos!',
    },
  },
  required: ['acceptance'],
  additionalProperties: false,
}

export default TermSchema
